import { login, logOut } from '@/api/user';
import { clearAll } from '@/utils/clear-user-information';

const state = {
  name: ''
};

const mutations = {
  SET_NAME: (data, name) => {
    data.name = name;
  }
};

const actions = {
  // user login
  // eslint-disable-next-line no-unused-vars
  login({ commit }, userInfo) {
    const { username, password, force } = userInfo;

    return new Promise((resolve, reject) => {
      login({
        mobile: username.trim(),
        pwd: password,
        force: force
      })
        .then((data) => {
          resolve(data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  logout() {
    return new Promise((resolve, reject) => {
      logOut()
        .then(() => {
          clearAll();

          resolve();
        })
        .catch((error) => {
          reject(error);
        });
    });
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions
};
